export enum ASK_AI_RULES {
    /**
     * @value Add answer
     * @description Indicate to the user that they can add an answer using the specified field or dialog.
     */
    ADD_ANSWER = 'ASK_AI_RULES.ADD_ANSWER',
    /**
     * @value Answer
     * @description Ask lumapps answer label
     */
    ANSWER = 'ASK_AI_RULES.ANSWER',
    /**
     * @value AI searches through documents to generate an answer.
     * @description Helper for the "sources" rule answer type
     */
    ANSWER_FROM_SOURCES_HELPER = 'ASK_AI_RULES.ANSWER_FROM_SOURCES_HELPER',
    /**
     * @value Rely on a source
     * @description Label for the "sources" rule answer type
     */
    ANSWER_FROM_SOURCES_LABEL = 'ASK_AI_RULES.ANSWER_FROM_SOURCES_LABEL',
    /**
     * @value {"one":"Answer from source: %SOURCE%","other":"Answer from sources: %SOURCE%"}
     * @description Rule answer info text when answer is of type source
     */
    ANSWER_IN_SOURCE = 'ASK_AI_RULES.RULE_ANSWER_IN_SOURCE',
    /**
     * @value If the following expressions are detected
     * @description Title of the concepts parameter block, in the rule form
     */
    CONCEPTS_BLOCK_TITLE = 'ASK_AI_RULES.CONCEPTS_BLOCK_TITLE',
    /**
     * @value Deleting the rule %TITLE% is irreversible. You will delete the entire configuration.
     * @description Delete rules dialog message
     */
    CONFIRM_DELETE_RULE = 'ASK_AI_RULES.CONFIRM_DELETE_RULE',
    /**
     * @value Custom answer
     * @description Place holder displayed in the rules admin's drawer when an answer is custom.
     */
    CUSTOM_ANSWER = 'ASK_AI_RULES.CUSTOM_ANSWER',
    /**
     * @value Answer is a custom answer
     * @description Placeholder displayed in the rules list when the answer of a rule is custom.
     */
    CUSTOM_ANSWER_DESCRIPTION = 'ASK_AI_RULES.CUSTOM_ANSWER_DESCRIPTION',
    /**
     * @value Set the answer manually
     * @description Title of the "custom answer" field of the rules form.
     */
    CUSTOM_ANSWER_TITLE = 'ASK_AI_RULES.CUSTOM_ANSWER_TITLE',
    /**
     * @value User card
     * @description Label for the user card custom rule
     */
    CUSTOM_RULE_USER_CARD_LABEL = 'ASK_AI_RULES.CUSTOM_RULE_USER_CARD_LABEL',
    /**
     * @value Delete rule
     * @description Delete rules dialog title
     */
    DELETE_RULE = 'ASK_AI_RULES.DELETE_RULE',
    /**
     * @value Edit answer
     * @description Title of the ask ai rule's edition dialog
     */
    EDIT_ANSWER = 'ASK_AI_RULES.EDIT_ANSWER',
    /**
     * @value Edit rule
     * @description Rule edition page title
     */
    EDIT_RULE = 'ASK_AI_RULES.EDIT_RULE',
    /**
     * @value Create rules to manage Ask AI answers based on specific expressions.
     * @description Rules list empty state message
     */
    EMPTY_STATE_MESSAGE = 'ASK_AI_RULES.EMPTY_STATE_MESSAGE',
    /**
     * @value Select the groups this rule applies to.
     * @description Description of the group section of the rule edition page
     */
    GROUPS_SECTION_DESCRIPTION = 'ASK_AI_RULES.GROUPS_SECTION_DESCRIPTION',
    /**
     * @value Add attachment
     * @description Label for the button for adding item for ask lumapps custom rules
     */
    INSERT_ACTIONABLE_ITEM_BUTTON_LABEL = 'ASK_AI_RULES.INSERT_ACTIONABLE_ITEM_BUTTON_LABEL',
    /**
     * @value A rule cannot contain more than %MAX_CONDITIONS% conditions.
     * @description Message displayed when the maximum concepts or-group has been reached
     */
    MAXIMUM_CONCEPTS_ERROR = 'ASK_AI_RULES.MAXIMUM_CONCEPTS_ERROR',
    /**
     * @value {"one":"%MAX_SOURCES% source maximum. You can add new sources in the \u201cSources\u201d page.","other":"%MAX_SOURCES% sources maximum. You can add new sources in the \u201cSources\u201d page."}
     * @description Maximum amount of sources to pick for a rule
     */
    MAXIMUM_SOURCES = 'ASK_AI_RULES.MAXIMUM_SOURCES',
    /**
     * @value {"one":"%MAX_SOURCES% source maximum","other":"%MAX_SOURCES% sources maximum"}
     * @description Maximum amount of sources to pick for a rule
     */
    MAXIMUM_SOURCES_ERROR = 'ASK_AI_RULES.MAXIMUM_SOURCES_ERROR',
    /**
     * @value New rule
     * @description New rule button label
     */
    NEW_RULE = 'ASK_AI_RULES.NEW_RULE',
    /**
     * @value No rules yet
     * @description Rules list empty state title
     */
    NO_RULES = 'ASK_AI_RULES.NO_RULES',
    /**
     * @value Manage the AI's answer based on the expressions detected in the user query.
     * @description Description of the rule parameters section of the rule form
     */
    PARAMETERS_SECTION_DESCRIPTION = 'ASK_AI_RULES.PARAMETERS_SECTION_DESCRIPTION',
    /**
     * @value Rules
     * @description Rules list title
     */
    RULES = 'ASK_AI_RULES.RULES',
    /**
     * @value Rule created.
     * @description Notification displayed on rule creation.
     */
    RULES_CREATED_NOTIFICATION = 'ASK_AI_RULES.RULES_CREATED_NOTIFICATION',
    /**
     * @value Rule deleted.
     * @description Notification displayed on rule deletion.
     */
    RULES_DELETED_NOTIFICATION = 'ASK_AI_RULES.RULES_DELETED_NOTIFICATION',
    /**
     * @value Rule updated.
     * @description Notification displayed on rule update.
     */
    RULES_UPDATED_NOTIFICATION = 'ASK_AI_RULES.RULES_UPDATED_NOTIFICATION',
    /**
     * @value Describe the rule
     * @description Description of the rule information section
     */
    RULE_INFO_BLOCK_DESCRIPTION = 'ASK_AI_RULES.RULE_INFO_BLOCK_DESCRIPTION',
}
